(function () {
  'use strict';

  function formatCLP(amount) {
    return '$' + Math.round(amount).toLocaleString('es-CL');
  }

  function updateBar(bar, cartTotalCents) {
    const threshold = parseInt(bar.dataset.threshold, 10);
    const cartTotal = Math.round(cartTotalCents / 100); // CLP no tiene decimales
    const remaining = Math.max(threshold - cartTotal, 0);
    const rawProgress = (cartTotal / threshold) * 100;
    const progress = Math.min(rawProgress, 100);
    const isComplete = progress >= 100;
    const isNear = progress >= 80 && !isComplete;

    // Actualizar fill
    const fill = bar.querySelector('[data-fsb-fill]');
    if (fill) {
      fill.style.width = progress + '%';
      fill.classList.toggle('fsb-fill--complete', isComplete);
    }

    // Actualizar camión
    const truck = bar.querySelector('[data-fsb-truck]');
    if (truck) {
      const containerWidth = bar.querySelector('.fsb-track').offsetWidth;
      const truckPos = (progress / 100) * containerWidth;
      truck.style.left = Math.max(0, truckPos - 14) + 'px';
    }

    // Actualizar mensaje
    const msg = bar.querySelector('[data-fsb-message]');
    if (msg) {
      if (isComplete) {
      msg.innerHTML = '🎉 Tienes despacho gratis!';
      } else if (cartTotal === 0) {
      msg.innerHTML = 'Agrega <strong>' + formatCLP(threshold) + '</strong> para tu despacho gratis';
      } else {
      msg.innerHTML = 'Agrega <strong>' + formatCLP(remaining) + '</strong> más para tu despacho gratis!';
      }
    }

    // Marcar como completo para estilos del regalo
    bar.toggleAttribute('data-complete', isComplete);

    // Color del ícono regalo
    const gift = bar.querySelector('.fsb-gift');
    if (gift) {
      gift.style.color = isComplete ? '#00d7ba' : '#999';
    }
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
          updateBar(bar, cart.total_price);
        });
      })
      .catch(function (err) {
        console.warn('[FreeShippingBar] Error fetching cart:', err);
      });
  }

  // Inicializar al cargar
  document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);

  // Escuchar eventos de Dawn theme (cart drawer updates)
  document.addEventListener('cart:refresh', fetchCartAndUpdate);
  document.addEventListener('cart:updated', fetchCartAndUpdate);

  // Evento nativo de Dawn (dispatch desde cart-drawer.js)
  document.addEventListener('dispatch:cart-update', fetchCartAndUpdate);

  // Mutation observer para cuando el drawer se abre/renderiza
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-free-shipping-bar]')) {
          fetchCartAndUpdate();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Exponer para uso manual si es necesario
  window.FreeShippingBar = { update: fetchCartAndUpdate };
})();
